const { VUE_APP_ENV: vueAPPEnv, VUE_APP_TENCENT_MAP_KEY: tencentMapKey } = process.env;

function setConfig(config, { development, test, preview, production }) {
  const domain = window.location.host;
  if (
    /^localhost/.test(domain)
    || /^saas.local.qq.com/.test(domain)
    || /\.nges\.local(:\d+)?$/.test(domain)
  ) {
    config = {
      ...config,
      ...development,
      tencentMapKey,
    };
    return config;
  }
  const configs = {
    development,
    test,
    preview,
    production,
  };
  for (const key in configs) {
    if (Object.prototype.hasOwnProperty.call(configs, key)) {
      const configItem = configs[key];
      // 数组格式：按 domain 匹配
      if (Array.isArray(configItem) && configItem.length) {
        const domainConfig = configItem.find((i) => i.domain && i.domain.includes(domain));
        if (domainConfig) {
          config = {
            ...config,
            ...domainConfig,
          };
          return config;
        }
        // 未匹配则继续检查下一个配置
        continue;
      }
      // 对象格式：按 env 匹配
      if (configItem && configItem.env === vueAPPEnv) {
        config = {
          ...config,
          ...configItem,
        };
        return config;
      }
    }
  }
  
  config = {
    ...config,
    ...production,
  };
  return config;
}
module.exports = {
  setConfig,
};
